<script>
	import {
		slugify,
		convertTextToObject,
		customStringify,
		sortKeys,
	} from "cando-util";

	import { store } from "$lib/utilities/store";

	import Textarea from "$lib/components/Textarea.svelte";
	import RenderJson from "$lib/components/RenderJSON/RenderJSON.svelte";
	import { getSupportedLanguagesAry } from "$lib/utilities/translate";

	export let col;
	export let settingId;
	export let fld;
	export let handleChange = () => {};
	export let lang;
	export let key = "";

	let isExpanded = false;

	$: fldObj = $store?.[col]?.docs?.[settingId]?.[fld];

	let updateTimeout;
	const handleInputChange = async (event) => {
		if (updateTimeout) {
			clearTimeout(updateTimeout);
		}

		updateTimeout = setTimeout(async () => {
			// this is the current doc field value
			const currentObj = $store[col].docs[settingId][fld].value;

			// this is going to be a translation which could be the default value
			const obj = convertTextToObject(textObject);

			// this is just going to be a flat object...
			for (const key of Object.keys(obj)) {
				if (lang === "") {
					obj[key] = {
						value: obj[key] || "",
						translations: { ...currentObj[key]?.translations },
					};
				} else {
					obj[key] = {
						value: currentObj[key]?.value || "",
						translations: {
							...currentObj[key]?.translations,
							[lang]: obj[key] || "",
						},
					};
				}
			}

			$store[col].docs[settingId][fld].value = obj;

			handleChange(event);
		}, 1000);
	};

	// $: textObject = getTextObject(fldObj, lang);
	let textObject;
	$: (() => {
		if (textObject === undefined) {
			textObject = getTextObject(fldObj, lang);
		}
	})();

	const getTextObject = (fldObj, lang) => {
		if (typeof fldObj !== "object") return;
		// convertObjectToText
		// console.log({ fld, fldObj });
		const objAry = [];
		for (const key of Object.keys(fldObj.value || {})) {
			if (lang === "") {
				objAry.push(`${key}: ${fldObj.value?.[key]?.value || ""}`);
			} else {
				objAry.push(
					`${key}: ${fldObj.value?.[key]?.translations?.[lang] || ""}`,
				);
			}
		}
		const textObj = objAry.sort().join("\n");

		return textObj;
	};

	const { defaultLanguageCode } = getSupportedLanguagesAry(
		$store?.settings?.docs?.languages,
	);
</script>

<label for={slugify(`${fld}`)}>text: {lang || defaultLanguageCode}</label>
<Textarea
	label={`${fld}-textObject`}
	bind:value={textObject}
	{handleInputChange}
	itemId={settingId}
	{key}
	additionalClass="font-mono"
/>

<RenderJson
	spacingClass="p-0 mt-2 sm:mt-4"
	widthClass="overflow-scroll"
	componentId={`${slugify(fld)}-value`}
	divIdPrefix="Setting"
	strJson={customStringify(sortKeys({ fldObj }), 2)}
	{isExpanded}
/>
